import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_array } from "@swc/helpers/_/_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { ScrollArea } from '@coveord/plasma-mantine';
import { forwardRef } from 'react';
export var FacetScrollArea = /*#__PURE__*/ forwardRef(function(_0, _1) {
    var _ref = [
        _0,
        _1
    ], _ref1 = _to_array(_ref), _ref2 = _ref1[0], _rest = _ref1.slice(1), style = _ref2.style, others = _object_without_properties(_ref2, [
        "style"
    ]), _rest1 = _sliced_to_array(_rest, 1), ref = _rest1[0];
    return /*#__PURE__*/ _jsx(ScrollArea, _object_spread_props(_object_spread({}, others), {
        style: _object_spread({
            width: '100%'
        }, style),
        viewportRef: ref,
        children: others.children
    }));
});

//# sourceMappingURL=FacetScrollArea.js.map